<template>
  <Chart
    chartID="affect-chart"
    type="line"
    :labels="labels"
    :datasets="datasets"
    v-if="dataLoaded"
  ></Chart>
</template>

<script>
import Chart from "../Chart.vue";

import { mapGetters } from "vuex";
import { format } from "date-fns";

export default {
  name: "Charts",
  props: ["existingEntries"],
  components: { Chart },
  data() {
    return {
      dataLoaded: false,
      labels: [],
      datasets: [
        {
          label: "Steps",
          data: [],
          borderColor: ["#00b4ae"],
          backgroundColor: ["#00b4ae"],
          fill: false,
          pointStyle: [],
        },

        {
          label: "Pain",
          data: [],
          backgroundColor: "gradient",
        },
      ],
    };
  },
  async mounted() {
    // Load our data and wait until it's done before setting loaded to true.
    await this.populateChart();
    this.dataLoaded = true;
  },

  computed: {
    ...mapGetters(["getPainEntries"]),
  },

  methods: {
    populateChart() {
      this.existingEntries.forEach((entry, index) => {
        // Check for matching pain entries.
        const matchingPainIndex = this.getPainEntries.findIndex(
          (painEntry) => painEntry.date.seconds === entry.date.seconds
        );

        // Add our pain entry to the dataset.
        if (matchingPainIndex > -1) {
          this.existingEntries[index].painEntry = this.getPainEntries[
            matchingPainIndex
          ];
        }
      });

      this.existingEntries
        .slice()
        .reverse()
        .forEach((entry) => {
          // Add label to chart.
          const day = format(entry.date.seconds * 1000, "MMMM D, YYYY");
          this.labels.push(day);

          // Add data to our chart.
          this.datasets[0].data.push(entry.steps > 10000 ? 10000 : entry.steps);

          // Add checkmark to the chart if user met their goal for the day.
          const walkingGoalPercentage =
            (entry.data.walkingTime / entry.data.walkingTimeGoal) * 100;

          if (walkingGoalPercentage >= 100) {
            const metGoal = new Image(16, 16);
            metGoal.src = "/app/img/check.svg";

            this.datasets[0].pointStyle.push(metGoal);
          } else {
            this.datasets[0].pointStyle.push("circle");
          }

          if (entry.painEntry) {
            this.datasets[1].data.push(entry.painEntry.data.painLevel * 100);
          } else {
            this.datasets[1].data.push("");
          }
        });
    },
  },
};
</script>

<style></style>
